import { isNullOrEmptyArray } from "src/util/arrays";

/**
 * Recalcula os dados plotados no gráfico de acordo com as legendas desabilitadas garatindo uma nova proporcionalidade
 * de porcentagens para cada item do gráfico.
 * @param {object} originalData Dados plotados no gráfico 
 * @param {array} disabledLegends Legendas desabilitadas
 * @param {boolean} allowPercentRecalcs flag que indica se deve ocorrer recálculo de porcenatgens
 * @returns 
 */
export const recalculateBarData = function (
  originalData = [],
  disabledLegends = [],
  allowPercentRecalcs = false
) {
  if (isNullOrEmptyArray(originalData)) {
    return [];
  }

  const numericValues = originalData
    .filter(({ enunciado }) => !disabledLegends.includes(enunciado))
    .map(({ resultado_numerico }) => resultado_numerico);

  let totalNumeric = numericValues.length
    ? numericValues.reduce((prev, current) => prev + current)
    : 0;

  return [
    ...originalData.map((dataItem) => {
      const isDisabled = disabledLegends.find(
        (item) => item === dataItem.enunciado
      );

      let percentualValue = dataItem.resultado_percentual;
      
      // Caso a flag seja true, será feito o cálculo de atribuição do novo percentual para o item do gráfico.
      if (allowPercentRecalcs && disabledLegends.length) {
        percentualValue = (dataItem.resultado_numerico / totalNumeric) * 100;
      }

      return {
        ...dataItem,
        // Caso a legenda correspondente ao item iterado esteja desabilitada, o valor percentual retornado será zero
        resultado_percentual: isDisabled ? 0 : percentualValue,
      };
    }),
  ];
};
